import { render, staticRenderFns } from "./PrDetail.vue?vue&type=template&id=625be385&scoped=true&"
import script from "./PrDetail.vue?vue&type=script&lang=js&"
export * from "./PrDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625be385",
  null
  
)

export default component.exports